import {ProductSearchLocal} from "@app/core/product/domain/repositories/product-search.local";

export class ProductSearchLocalStorage implements ProductSearchLocal {

    private RECENT_SEARCHES_KEY = 'recent-searches';

    private readonly maxQuantityOfRecentSearches = 10;

    getRecentSearches(): string[] {
        const recentSearchesString = localStorage.getItem(this.RECENT_SEARCHES_KEY)
        const recentSearches = recentSearchesString ? JSON.parse(recentSearchesString) as string[] : [];
        return recentSearches.reverse();
    }

    addRecentSearch(query: string) {
        let recentSearches = this.getRecentSearches().reverse();
        const recentSearchesSet = new Set(recentSearches);
        recentSearchesSet.add(query);
        recentSearches = Array.from(recentSearchesSet);

        const difference = recentSearches.length - this.maxQuantityOfRecentSearches;

        if(difference > 0) {
            recentSearches.splice(0,difference);
        }

        localStorage.setItem(this.RECENT_SEARCHES_KEY,JSON.stringify(recentSearches));
    }

    deleteRecentSearch(index: number) {
        let recentSearches = this.getRecentSearches();
        // Remove the search item at the specified index (removes 1 element)
        recentSearches.splice(index,1);
        // Save reversed because the recent searches are stored in reverse order, the last element is the most recent.
        localStorage.setItem(this.RECENT_SEARCHES_KEY,JSON.stringify([...recentSearches].reverse()));
    }
}